import { jsx as e } from "react/jsx-runtime";
import { cloneElement as t, isValidElement as n } from "react";
//#region src/components/controls/ControlIcon.tsx
var r = ({ children: r, size: i }) => /* @__PURE__ */ e("span", {
	className: "pf-control-icon pf:inline-flex pf:items-center pf:justify-center pf:flex-none pf:leading-[0]",
	"aria-hidden": "true",
	children: n(r) ? t(r, typeof r.type == "string" ? {
		width: i,
		height: i
	} : {
		size: i,
		width: i,
		height: i,
		tone: "inherit"
	}) : r
});
//#endregion
export { r as ControlIcon };
